import { Briefcase, Facebook, Twitter, Linkedin, Mail, Instagram } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    'Para candidatos': [
      { label: 'Ver vacantes', href: '#' },
      { label: 'Consejos prácticos', href: '#' },
    ],
    'Para empleadores': [
      { label: 'Reportar vacante', href: '#' },
      { label: 'Casos de éxito', href: '#' },
    ],
    'Compañía': [
      { label: 'Sobre Nosotros', href: '#' },
      { label: 'Blog', href: '#' },
      
    ],
  };

  const socialLinks = [
    { icon: Facebook, label: 'Facebook', href: '#' },
    { icon: Instagram, label: 'Instagram', href: '#' },
    { icon: Linkedin, label: 'LinkedIn', href: '#' },
    { icon: Mail, label: 'Email', href: '#' },
  ];

  return (
    <footer className="bg-violet-950 text-gray-300">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-violet-900 rounded-lg flex items-center justify-center">
                <img class="h-20" src="/svg/logo-vacantes.svg" alt="Logo"></img>
              </div>
              <span className="text-lg font-bold text-white">Vacantes Panamá</span>
            </div>
            <p className="text-sm text-gray-400 mb-6">
              Contiene una lista depurada de vacantes en Panamá con información de contacto
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    className="w-10 h-10 bg-violet-900 rounded-lg flex items-center justify-center hover:bg-violet-700 transition-colors group"
                    aria-label={social.label}
                  >
                    <Icon size={18} className="text-gray-400 group-hover:text-white" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Links Sections */}
          {Object.entries(footerLinks).map(([section, links]) => (
            <div key={section}>
              <h3 className="text-white font-semibold mb-4">{section}</h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-gray-400 hover:text-white transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Legal Links */}
            <div className="flex flex-wrap gap-6 text-sm text-gray-400">
              <a href="#" className="hover:text-white transition-colors">
                Política de Privacidad
              </a>
              <a href="#" className="hover:text-white transition-colors">
                Términos de Uso
              </a>
              <a href="#" className="hover:text-white transition-colors">
                Política de Cookies
              </a>
              <a href="#" className="hover:text-white transition-colors">
                Responsabilidad Social
              </a>
            </div>

            {/* Copyright */}
            <div className="text-sm text-gray-400 md:text-right">
              <p>
                &copy; {currentYear} VacantesPanamá. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
